export const ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  TRAINING_OFFICER: 'Training Manager',
  TRAINING_OFFICER_SHORT_HAND: 'Training Mgr.',
  USER: 'Trainee',
};

export const COURSE_DELIVERY_TYPE = {
  ONLINE: 'Online',
  IN_PERSON: 'InPerson',
};

export const ROLE_OPTIONS = [
  { text: ROLES.USER, value: 'Trainee' },
  { text: ROLES.TRAINING_OFFICER, value: 'Training Manager' },
  { text: ROLES.ADMIN, value: 'Admin' },
];

export const NAVIGATION_ITEMS = [
  {
    path: '/reporting',
    label: 'Reporting',
    routeNames: ['Reporting'],
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TRAINING_OFFICER],
  },
  {
    path: '/policies',
    label: 'Policy',
    routeNames: ['Policy'],
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TRAINING_OFFICER],
    isPolicy: true,
  },
  {
    path: '/courses',
    label: 'Courses',
    routeNames: ['CourseManagement'],
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TRAINING_OFFICER],
  },
  {
    path: '/users',
    label: 'Users',
    routeNames: ['UserManagement', 'UserDetail'],
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  },
  {
    path: '/downloads',
    label: 'Download',
    routeNames: ['AppDownload', 'AppDownloadDetails'],
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TRAINING_OFFICER, ROLES.USER],
  },
  {
    path: '/faq',
    label: 'FAQs',
    routeNames: ['FAQ'],
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TRAINING_OFFICER, ROLES.USER],
  },
  {
    path: '/help',
    label: 'Help',
    routeNames: ['Help'],
    roles: [], // ['Admin', 'Training Officer', 'User'],
  },
];

export const SUPER_ADMIN_NAV_ITEMS = [
  {
    path: '/super-admins',
    label: 'Super Admins',
    routeNames: ['SuperAdmins'],
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: '/security',
    label: 'Security',
    routeNames: ['Security', 'SecurityEvents', 'SecurityBlacklist'],
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: '/messages',
    label: 'Messages',
    routeNames: [
      'Messages',
      'MessageDistributionList',
      'MessageDistributionListDetail',
      'MessageDistributionListDetailEdit',
      'New Message',
      'Edit Message',
    ],
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: '/tc-violations',
    label: 'T&C Violations',
    routeNames: ['Violations'],
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: '/org-management',
    label: 'Organizations',
    routeNames: ['OrgManagement', 'OrgDetail'],
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: '/faq-update',
    label: 'Edit FAQs',
    routeNames: ['FAQ Update'],
    roles: [ROLES.SUPER_ADMIN],
  },
];

export const COURSE_ASSIGNMENT_STATUS = {
  INCOMPLETE: 0,
  BEHIND_SCHEDULE: 1,
  ON_SCHEDULE: 2,
  COMPLETED: 3,
  SUPPORT_REQUEST: 4,
};

export const DEFAULT_COURSE_ASSIGNMENTS_PAGE_SIZE = 100;

export const POST_SUBMISSION_STATUS = {
  PENDING: 'SubmissionPending',
  ACCEPTED: 'SubmissionAccepted',
  FAILED: 'SubmissionFailed',
};

const BASE_STATUS_OPTIONS = [
  { text: 'Past Due', name: 'Incomplete', variant: 'secondary' },
  { text: 'Behind Schedule', name: 'Behind', variant: 'warning' },
  { text: 'On Schedule', name: 'OnSchedule', variant: 'normal' },
  {
    text: 'Needs In-Person Training',
    name: 'NeedsInPersonTraining',
    variant: 'warning',
  },
];

export const COMPLETED_STATUS_OPTIONS = [
  {
    text: 'Completed - Credit Processing',
    name: POST_SUBMISSION_STATUS.PENDING,
    variant: 'success',
  },
  {
    text: 'Completed - Credit Accepted',
    name: POST_SUBMISSION_STATUS.ACCEPTED,
    variant: 'success',
  },
  {
    text: 'Completed - Credit Failed',
    name: POST_SUBMISSION_STATUS.FAILED,
    variant: 'success',
  },
];

export const STATUS_OPTION_LIST = [
  ...BASE_STATUS_OPTIONS,
  { text: 'Completed', name: 'Complete', variant: 'success' },
];

export const EXTENDED_STATUS_OPTIONS = [
  ...BASE_STATUS_OPTIONS,
  ...COMPLETED_STATUS_OPTIONS,
];

export const RATING_OPTION_LIST = [
  { id: 1, value: 1, text: '1 Stars' },
  { id: 2, value: 2, text: '2 Stars' },
  { id: 3, value: 3, text: '3 Stars' },
  { id: 4, value: 4, text: '4 Stars' },
  { id: 5, value: 5, text: '5 Stars' },
];

export const ORG_PROGRESS_TABLE_FIELDS = [
  { key: 'course', sortable: false },
  { key: 'officers', label: 'Total completed', sortable: false },
  { key: 'percent', label: 'Percent complete', sortable: false },
];

export const COURSE_ASSIGNMENT_TABLE_FIELDS = [
  { key: 'selected', label: '', sortable: false },
  { key: 'name', label: 'Name', sortable: true },
  { key: 'courseName', label: 'Course', sortable: true },
  { key: 'status', label: 'Status', sortable: true },
  { key: 'startDate', label: 'Assigned', sortable: true },
  { key: 'completionDate', label: 'Due Date', sortable: true },
  {
    key: 'assignedByUserId',
    label: ROLES.TRAINING_OFFICER_SHORT_HAND,
    sortable: true,
    thStyle: { minWidth: '130px', whiteSpace: 'nowrap' },
  },
  { key: 'completedOn', label: 'Completed', sortable: true },
];

export const OFFICER_USAGE_TABLE_FIELDS = [
  { key: 'courseName', label: 'Course', sortable: true },
  { key: 'status', label: 'Status', sortable: true },
  { key: 'startDate', label: 'Assigned', sortable: true },
  { key: 'completionDate', label: 'Due Date', sortable: true },
  {
    key: 'assignedByUserId',
    label: ROLES.TRAINING_OFFICER_SHORT_HAND,
    sortable: true,
    thStyle: { minWidth: '130px', whiteSpace: 'nowrap' },
  },
  { key: 'completedOn', label: 'Completed', sortable: true },
  { key: 'hasSupportRequest', label: 'Support Request', sortable: true },
];

export const OFFICER_LIST_TABLE_FIELDS = [
  { key: 'firstName', label: 'First', sortable: true },
  { key: 'lastName', label: 'Last', sortable: true },
  { key: 'email', label: 'Email', sortable: true },
  { key: 'postId', label: 'POST ID', sortable: true },
  { key: 'mostPrivilegedRole', label: 'Type', sortable: true },
  { key: 'active', label: 'Active', sortable: true },
  { key: 'assignedCoursesCount', label: 'Assigned', sortable: true },
  { key: 'completedCoursesCount', label: 'Complete', sortable: true },
  { key: 'violatedTerms', label: 'Locked', sortable: true },
];

export const CSV_USER_TABLE_FIELDS = [
  { key: 'firstName', label: 'First', sortable: true },
  { key: 'middleName', label: 'Middle', sortable: true },
  { key: 'lastName', label: 'Last', sortable: true },
  { key: 'email', label: 'Email', sortable: true },
  { key: 'upn', label: 'UPN', sortable: true },
  { key: 'postId', label: 'POST ID', sortable: true },
  { key: 'type', label: 'Type', sortable: true },
  { key: 'notes', label: 'System Message', sortable: true },
];

export const ORG_TABLE_FIELDS = [
  { key: 'name', label: 'Organization', sortable: true },
  { key: 'state', label: 'State', sortable: true },
  { key: 'timeZoneId', label: 'Timezone', sortable: true },
];

export const SUPER_ADMINS_TABLE_FIELDS = [
  { key: 'firstName', label: 'First', sortable: true },
  { key: 'lastName', label: 'Last', sortable: true },
  { key: 'email', label: 'Email', sortable: true },
  { key: 'dateLastLoggedIn', label: 'Last Login', sortable: true },
];

export const VIOLATIONS_TABLE_FIELDS = [
  { key: 'firstName', label: 'First', sortable: true },
  { key: 'lastName', label: 'Last', sortable: true },
  { key: 'organization', label: 'Organization', sortable: true },
  { key: 'violationType', label: 'Violation', sortable: true },
  { key: 'numberOfViolationLockouts', label: 'Lockouts', sortable: true },
  { key: 'lastViolationOn', label: 'Timestamp', sortable: true },
];

export const AVAILABLE_COURSES_TABLE_FIELDS = [
  { key: 'cycleName', label: 'Cycle', sortable: true },
  { key: 'unifierName', label: 'Unifier', sortable: true },
  { key: 'name', label: 'Display Name', sortable: true },
  { key: 'active', label: 'Active', sortable: true },
  { key: 'versions', label: 'Course Version', sortable: false },
  { key: 'numberOfLicenses', label: 'Licenses Purchased*', sortable: true },
  { key: 'licenseExpiration', label: 'Licenses Expiration*', sortable: true },
  {
    key: 'courseAssignmentCount',
    label: 'Assignments Created',
    sortable: true,
  },
  { key: 'licensesUsed', label: 'Licenses Used', sortable: true },
  { key: 'save', label: '', sortable: true },
];

export const SECURITY_EVENTS_TABLE_FIELD = [
  { key: 'violatedOn', label: 'Time', sortable: true },
  { key: 'clientId', label: 'Platform', sortable: true },
  { key: 'type', label: 'Violation', sortable: true },
  { key: 'ipAddress', label: 'IP Address', sortable: true },
  { key: 'country', label: 'Location', sortable: true },
  { key: 'organizationName', label: 'Organization', sortable: true },
  { key: 'operatingSystem', label: 'OS', sortable: true },
  { key: 'violationCount', label: 'Violation', sortable: true },
];
export const REVIEW_TABLE_FIELDS = [
  { key: 'organizationName', label: 'Organization', sortable: true },
  { key: 'rating', label: 'Rating', sortable: true },
  { key: 'courseName', label: 'Course', sortable: true },
  { key: 'message', label: 'Comment', sortable: true },
  { key: 'date', label: 'Timestamp', sortable: true },
];

export const SECURITY_BLACKLIST_TABLE_FIELD = [
  { key: 'blockedOn', label: 'Time', sortable: true },
  { key: 'violationCount', label: 'Violation', sortable: true },
  { key: 'identifierType', label: 'Block Type', sortable: true },
  { key: 'identifier', label: 'Block Identifier', sortable: true },
  { key: 'violationType', label: 'Reason', sortable: true },
  {},
];

export const MESSAGE_DISTRIBUTION_LIST_TABLE_FIELD = [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'rules', label: 'Rules', sortable: true },
];

export const VIOLATION_METRICS = {
  ScreenCapture: 'Screenshot/Recording Locks',
  LoginGuessed: 'Username Guessing',
  LoginOutsideCountry: 'Attempted Logins Outside US',
  FailedLoginClientSite: 'Failed Login Locks',
  FailedLoginTrainingApp: 'Failed Login Locks',
  LoginOutsideState: 'Attempted Access Outside Home State',
  ConcurrentClientSiteSessionBlock: 'Concurrent Session Blocks',
  ConcurrentTrainingAppSessionBlock: 'Concurrent Session Blocks',
  FrequentLogin: 'Frequent Logins',
  MultipleAccountsOnSameDevice: 'Multiple Accounts on Same Device',
  MultiDeviceType: 'Multiple Device Types',
  MultiDeviceClientSite: 'Login on Multiple Devices',
  DownloadRequest: 'Multiple Downloads',
};

export const SECURITY_EVENTS_FILTER_MAPPING = {
  violationType: 'Violation',
  clientId: 'Platform',
  startDate: 'Start Date',
  endDate: 'End Date',
  category: 'Category',
  operatingSystem: 'Operating System',
  browserName: 'Browser',
  deviceName: 'Device',
  macAddress: 'Mac Address',
  ipAddress: 'IP Address',
  browserFingerprint: 'Fingerprint',
  organizationId: 'Organization',
  email: 'Email',
  // TODO: recheck labels for aggregations
  aggregatedViolationCount: 'Violation Count',
  aggregatedViolationCountType: 'Violation Type',
  aggregatedViolationCountComparison: 'Violation Comparison',
};

export const AGGREGATED_VIOLATION_TYPES = [
  { value: 'BrowserFingerprint', text: 'BrowserFingerprint' },
  { value: 'DeviceUuid', text: 'Uuid' },
  { value: 'MacAddress', text: 'MacAddress' },
  { value: 'IpAddress', text: 'IpAddress' },
  { value: 'OrganizationId', text: 'Organization' },
  { value: 'UserId', text: 'UserId' },
];
export const AGGREGATED_VIOLATION_OPERATORS = [
  { value: 'EqualTo', text: 'equal to' },
  { value: 'GreaterThan', text: 'greater than' },
  { value: 'GreaterThanOrEqualTo', text: 'greater than or equal to' },
  { value: 'LessThanOrEqualTo', text: 'less than or equal to' },
  { value: 'LessThan', text: 'less than' },
];

export const CLIENT_ID_OPTIONS = [
  { text: 'Performa App', value: 'Training App' },
  { text: 'Client Dashboard', value: 'Client Site' },
];

export const OPERATING_SYSTEM_OPTIONS = [
  { text: 'iOS', value: 'Ios' },
  { text: 'MacOS', value: 'Mac' },
  { text: 'Android', value: 'Android' },
  { text: 'Windows', value: 'Windows' },
];

export const OPERATING_SYSTEMS = {
  MACOS: 'Mac OS X',
  IOS: 'iOS',
  WINDOWS: 'Windows',
  ANDROID: 'Android',
  LINUX: 'Linux',
};

export const SUPPORTED_BROWSERS = {
  SAFARI: 'Safari',
  EDGE: 'Edge',
  CHROME: 'Chrome',
};

export const DEVICE_CLASS = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

export const AUTH_CLIENT_ID = 'Client Site';

export const AUTHENTICATION_TYPES = {
  PERFORMA: 'Performa',
  AZURE: 'AzureAd',
  ADFS: 'Adfs',
  OKTA: 'Okta',
};

export const SSO_CLIENT_TYPES = {
  CLIENT_SITE: 'Client Site',
};

export const SSO_SYNC_STATUS = {
  DEFAULT: null,
  SUCCESS: 'Succeeded',
  FAILURE: 'Failed',
  RUNNING: 'Running',
  LAUNCHING: 'Launching',
};

export const SUPPORT_REQUEST_TYPES = {
  SCENARIO: 'Scenario',
  ACCOUNT: 'Account',
};

export const IOS_DISTRIBUTION_TYPES = {
  APP_STORE: 'AppleBusinessManager',
  IT_MANAGED: 'ItManaged',
};

export const IOS_DISTRIBUTION_TYPE_OPTIONS = [
  {
    value: IOS_DISTRIBUTION_TYPES.APP_STORE,
    text: 'App Store',
  },
  { value: IOS_DISTRIBUTION_TYPES.IT_MANAGED, text: 'MDM' },
  { value: null, text: 'N/A' },
];

export const ANDROID_DISTRIBUTION_TYPE = {
  S3_AUTHENTICATED_DOWNLOAD: 'S3AuthenticatedDownload',
  IT_MANAGED: 'ItManaged',
};

export const ANDROID_DISTRIBUTION_TYPE_OPTIONS = [
  {
    value: ANDROID_DISTRIBUTION_TYPE.S3_AUTHENTICATED_DOWNLOAD,
    text: 'S3 Authenticated Download',
  },
  { value: ANDROID_DISTRIBUTION_TYPE.IT_MANAGED, text: 'IT Managed' },
  { value: null, text: 'N/A' },
];

export const WINDOWS_DISTRIBUTION_TYPE = {
  S3_AUTHENTICATED_DOWNLOAD: 'S3AuthenticatedDownload',
  IT_MANAGED: 'ItManaged',
};

export const WEB_DISTRIBUTION_TYPE = {
  WEB: 'Web',
};

export const WEB_DISTRIBUTION_TYPE_OPTIONS = [
  { value: WEB_DISTRIBUTION_TYPE.WEB, text: 'Web' },
  { value: null, text: 'N/A' },
];

// messaging platform
export const CRITERIA_IDENTIFIER = {
  STATE: {
    label: 'State',
    field: 'state',
  },
  ORGANIZATION: {
    label: 'UserOrganization',
    field: 'organizationId',
  },
  ROLE: {
    label: 'Role',
    field: 'roleName',
  },
  EMAIL: {
    label: 'Email',
    field: 'email',
  },
  STATUS: {
    label: 'CourseAssignmentStatus',
    field: 'courseAssignmentStatus',
  },
};

export const CRITERIA_TYPE = {
  IS: 'Is',
  IS_NOT: 'IsNot',
  INCLUDES: 'Includes',
};

export const CRITERIA_TYPE_OPTIONS = [
  // PERFCS-1997 - We removed "is", and "includes" became "is"
  { label: 'is', value: CRITERIA_TYPE.INCLUDES },
  { label: 'is not', value: CRITERIA_TYPE.IS_NOT },
];

export const MESSAGE_TYPE = {
  EMAIL: 'Email',
  PUSH_NOTIFICATION: 'PushNotification',
  MARKETING: 'MarketingMessage',
  BANNER: 'Banner',
  CS_MARKETING_MESSAGE: 'ClientSiteMarketingMessage',
};

export const MESSAGE_TYPE_LABEL = {
  [MESSAGE_TYPE.EMAIL]: MESSAGE_TYPE.EMAIL,
  [MESSAGE_TYPE.PUSH_NOTIFICATION]: 'Push Notification',
  [MESSAGE_TYPE.MARKETING]: 'In-App Marketing Message',
  [MESSAGE_TYPE.BANNER]: 'Client Site Banner',
  [MESSAGE_TYPE.CS_MARKETING_MESSAGE]: 'Client Site Marketing Message',
};

export const MESSAGE_TYPE_OPTIONS = [
  { text: MESSAGE_TYPE_LABEL[MESSAGE_TYPE.EMAIL], value: MESSAGE_TYPE.EMAIL },
  {
    text: MESSAGE_TYPE_LABEL[MESSAGE_TYPE.PUSH_NOTIFICATION],
    value: MESSAGE_TYPE.PUSH_NOTIFICATION,
  },
  {
    text: MESSAGE_TYPE_LABEL[MESSAGE_TYPE.MARKETING],
    value: MESSAGE_TYPE.MARKETING,
  },
  { text: MESSAGE_TYPE_LABEL[MESSAGE_TYPE.BANNER], value: MESSAGE_TYPE.BANNER },
  {
    text: MESSAGE_TYPE_LABEL[MESSAGE_TYPE.CS_MARKETING_MESSAGE],
    value: MESSAGE_TYPE.CS_MARKETING_MESSAGE,
  },
];

export const MESSAGE_TARGET_TYPE = {
  ALL: 'AllUsers',
  DISTRIBUTION_LIST: 'DistributionList',
  DEPARTMENT_AND_ROLE: 'DepartmentAndRole',
  DEPARTMENT: 'Department',
  ROLE: 'Role',
  USER: 'User',
};
export const MESSAGE_TARGET_TYPE_OPTIONS = [
  { text: 'All Users', value: MESSAGE_TARGET_TYPE.ALL },
  { text: 'Distribution List', value: MESSAGE_TARGET_TYPE.DISTRIBUTION_LIST },
  {
    text: 'Department And Role',
    value: MESSAGE_TARGET_TYPE.DEPARTMENT_AND_ROLE,
  },
  { text: 'Department', value: MESSAGE_TARGET_TYPE.DEPARTMENT },
  { text: 'Role', value: MESSAGE_TARGET_TYPE.ROLE },
  { text: 'User', value: MESSAGE_TARGET_TYPE.USER },
];
export const MESSAGE_COURSE_TARGET_TYPE_OPTIONS = [
  { text: 'Active course', value: 'Active' },
  { text: 'No active course', value: 'NotActive' },
  { text: 'Both', value: 'Both' },
];

export const STATES = [
  { value: 'AK', text: 'Alaska' },
  { value: 'AL', text: 'Alabama' },
  { value: 'AR', text: 'Arkansas' },
  { value: 'AZ', text: 'Arizona' },
  { value: 'CA', text: 'California' },
  { value: 'CO', text: 'Colorado' },
  { value: 'CT', text: 'Connecticut' },
  { value: 'DC', text: 'District of Columbia' },
  { value: 'DE', text: 'Delaware' },
  { value: 'FL', text: 'Florida' },
  { value: 'GA', text: 'Georgia' },
  { value: 'HI', text: 'Hawaii' },
  { value: 'IA', text: 'Iowa' },
  { value: 'ID', text: 'Idaho' },
  { value: 'IL', text: 'Illinois' },
  { value: 'IN', text: 'Indiana' },
  { value: 'KS', text: 'Kansas' },
  { value: 'KY', text: 'Kentucky' },
  { value: 'LA', text: 'Louisiana' },
  { value: 'MA', text: 'Massachusetts' },
  { value: 'MD', text: 'Maryland' },
  { value: 'ME', text: 'Maine' },
  { value: 'MI', text: 'Michigan' },
  { value: 'MN', text: 'Minnesota' },
  { value: 'MO', text: 'Missouri' },
  { value: 'MS', text: 'Mississippi' },
  { value: 'MT', text: 'Montana' },
  { value: 'NC', text: 'North Carolina' },
  { value: 'ND', text: 'North Dakota' },
  { value: 'NE', text: 'Nebraska' },
  { value: 'NH', text: 'New Hampshire' },
  { value: 'NJ', text: 'New Jersey' },
  { value: 'NM', text: 'New Mexico' },
  { value: 'NV', text: 'Nevada' },
  { value: 'NY', text: 'New York' },
  { value: 'OH', text: 'Ohio' },
  { value: 'OK', text: 'Oklahoma' },
  { value: 'OR', text: 'Oregon' },
  { value: 'PA', text: 'Pennsylvania' },
  { value: 'RI', text: 'Rhode Island' },
  { value: 'SC', text: 'South Carolina' },
  { value: 'SD', text: 'South Dakota' },
  { value: 'TN', text: 'Tennessee' },
  { value: 'TX', text: 'Texas' },
  { value: 'UT', text: 'Utah' },
  { value: 'VA', text: 'Virginia' },
  { value: 'VT', text: 'Vermont' },
  { value: 'WA', text: 'Washington' },
  { value: 'WI', text: 'Wisconsin' },
  { value: 'WV', text: 'West Virginia' },
  { value: 'WY', text: 'Wyoming' },
];

export const TIMEZONES = [
  { text: '(GMT-10:00) America/Adak', value: 'America/Adak' },
  { text: '(GMT-10:00) Pacific/Honolulu', value: 'Pacific/Honolulu' },
  { text: '(GMT-09:00) America/Anchorage', value: 'America/Anchorage' },
  { text: '(GMT-09:00) America/Juneau', value: 'America/Juneau' },
  { text: '(GMT-09:00) America/Metlakatla', value: 'America/Metlakatla' },
  { text: '(GMT-09:00) America/Nome', value: 'America/Nome' },
  { text: '(GMT-09:00) America/Sitka', value: 'America/Sitka' },
  { text: '(GMT-09:00) America/Yakutat', value: 'America/Yakutat' },
  { text: '(GMT-08:00) America/Los_Angeles', value: 'America/Los_Angeles' },
  { text: '(GMT-07:00) America/Boise', value: 'America/Boise' },
  { text: '(GMT-07:00) America/Denver', value: 'America/Denver' },
  {
    text: '(GMT-07:00) America/North_Dakota/Beulah',
    value: 'America/North_Dakota/Beulah',
  },
  {
    text: '(GMT-07:00) America/North_Dakota/New_Salem',
    value: 'America/North_Dakota/New_Salem',
  },
  { text: '(GMT-07:00) America/Phoenix', value: 'America/Phoenix' },
  { text: '(GMT-06:00) America/Chicago', value: 'America/Chicago' },
  { text: '(GMT-06:00) America/Indiana/Knox', value: 'America/Indiana/Knox' },
  {
    text: '(GMT-06:00) America/Indiana/Petersburg',
    value: 'America/Indiana/Petersburg',
  },
  {
    text: '(GMT-06:00) America/Indiana/Tell_City',
    value: 'America/Indiana/Tell_City',
  },
  {
    text: '(GMT-06:00) America/Indiana/Vincennes',
    value: 'America/Indiana/Vincennes',
  },
  {
    text: '(GMT-06:00) America/Indiana/Winamac',
    value: 'America/Indiana/Winamac',
  },
  {
    text: '(GMT-06:00) America/Kentucky/Monticello',
    value: 'America/Kentucky/Monticello',
  },
  { text: '(GMT-06:00) America/Menominee', value: 'America/Menominee' },
  {
    text: '(GMT-06:00) America/North_Dakota/Center',
    value: 'America/North_Dakota/Center',
  },
  { text: '(GMT-05:00) America/Detroit', value: 'America/Detroit' },
  {
    text: '(GMT-05:00) America/Indiana/Indianapolis',
    value: 'America/Indiana/Indianapolis',
  },
  {
    text: '(GMT-05:00) America/Indiana/Marengo',
    value: 'America/Indiana/Marengo',
  },
  { text: '(GMT-05:00) America/Indiana/Vevay', value: 'America/Indiana/Vevay' },
  {
    text: '(GMT-05:00) America/Kentucky/Louisville',
    value: 'America/Kentucky/Louisville',
  },
  { text: '(GMT-05:00) America/New_York', value: 'America/New_York' },
];

export const ANSWER_OVERRIDE_QUIZ_TYPES = {
  SINGLE_CHOICE: 'SingleChoice',
  MULTI_CHOICE: 'MultiChoice',
};

export const COURSE_URL_TYPES = {
  LINK: 'Link',
  DOCUMENT: 'Document',
};

export const ONBOARDING_STATUSES = {
  PREPARATION: 'Preparation',
  IT_OPTIONS: 'ItOptions',
  IMPORT_USER_DATA: 'ImportUserData',
  COMPLETE: 'Complete',
  EXTERNAL_IDP: 'ExternalIdP',
};

export const ONBOARDING_STATUS_DISPLAY_LABELS = [
  { text: 'Preparation', value: ONBOARDING_STATUSES.PREPARATION },
  { text: 'IT Options', value: ONBOARDING_STATUSES.IT_OPTIONS },
  { text: 'Import User Data', value: ONBOARDING_STATUSES.IMPORT_USER_DATA },
  { text: 'Complete', value: ONBOARDING_STATUSES.COMPLETE },
  { text: 'External Idp', value: ONBOARDING_STATUSES.EXTERNAL_IDP },
];

export const EXTERNAL_ATTRIBUTE_UI_AREAS = {
  COURSES: 'Courses',
  USERS: 'Users',
  COURSE_ASSIGNMENT_MODAL: 'CourseAssignmentModal',
};
